!((document, Drupal, $) => {
  'use strict';

  /**
   * Main theme JS
   */
  Drupal.behaviors.global = {
    attach: function () {
      const $html = $('html');

      // Auto open popin if homepage.
      once('autoOpenPopinIfHomepage', 'html').forEach(function () {
        if ($html.hasClass('homepage') && !$html.hasClass('authenticated')) {
          $html.addClass('login-popup-form-open');
          setTimeout(function () {
            $('.login-popup-form').click();
          }, 250);
        }
      });

      once('adaptContentHeight', '.layout-main').forEach(function (main) {
        const $main = $(main);
        const padding = parseInt($main.css('padding-top'));
        const windowHeight = $(window).height();
        const headerHeight = $('header').height();
        const footerHeight = $('footer').height();

        let height = windowHeight + padding - headerHeight - footerHeight;
        height =  height > windowHeight ? windowHeight : height;

        $main.css('min-height', height + 'px');

        // Also adjust storytelling slider and other components depending on footer height.
        $('.paragraph--type-storytelling').css('height', (windowHeight - headerHeight - footerHeight) + 'px');
      });

    },
  };

})(document, Drupal, jQuery);
